var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Create, ReferenceInput, SelectInput, SimpleForm, TextInput, useRefresh, useNotify, required, } from "react-admin";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { useTenantStore } from "@/providers/TenantContextProvider";
var Hidden = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: none;\n"], ["\n    display: none;\n"])));
export var SettingsTrusteesCreate = function (props) {
    var close = props.close;
    var refresh = useRefresh();
    var notify = useNotify();
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var onSuccess = function () {
        refresh();
        if (close) {
            close();
        }
    };
    var onError = function (error) {
        notify(error.message, { type: "error" });
        refresh();
        if (close) {
            close();
        }
    };
    return (_jsx(Create, { mutationOptions: {
            onSuccess: close ? onSuccess : undefined,
            onError: close ? onError : undefined,
        }, redirect: close ? false : "settings", resource: "sequent_backend_trustee", children: _jsxs(SimpleForm, { children: [_jsx(PageHeaderStyles.Title, { children: t("trusteesSettingsScreen.create.title") }), _jsx(TextInput, { source: "name", validate: required() }), _jsx(TextInput, { source: "public_key", validate: required(), helperText: "Signing public key from trustee public-keys" }), _jsx(TextInput, { source: "share_encryption_public_key", validate: required(), helperText: "Share encryption public key from trustee public-keys" }), _jsx(Hidden, { children: _jsx(ReferenceInput, { source: "tenant_id", reference: "sequent_backend_tenant", children: _jsx(SelectInput, { optionText: "slug", defaultValue: tenantId }) }) })] }) }));
};
var templateObject_1;
